Vue.component("MpExpandableBox", {
    props: {
        label: {
            type: String,
            default: function () {
                return '';
            }
        },
        collapsable: {
            type: Number,
            default: 0
        },
        maxHeight: {
            type: Number,
            default: 240
        }
    },

    data: function() {
        return {
            isOpen: false,
            allowCollapsedDetail: false
        };
    },

    computed: {},

    methods: {
        open: function() {
            this.isOpen = true;
        }
    },

    mounted: function() {
        if (this.collapsable) {
            this.$refs.content.style.maxHeight = this.maxHeight + 'px';
        }
    },

    template: '\
    <div class="expandable-box" :class="{ \'expandable-box--open\': isOpen }" ref="content">\
        <slot></slot>\
        <div class="expandable-box__more" v-if="collapsable && !isOpen"><a href="#" @click.prevent="open">{{ label }}</a></div>\
    </div>',
});
